<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="row" data-test-view="team-settings">
            <div class="col-md-2 hidden-xs">
                <l-side-menu>
                    <l-side-menu-picture :src="icon"></l-side-menu-picture>

                    <l-side-menu-element
                        v-for="item in menu"
                        :key="item.path"
                        :show="item.show"
                        :type="item.type"
                        :icon="item.icon"
                        :label="item.label"
                        :path="item.path"
                        :handler="() => goTo(item.path)"
                        :active="item.active"
                    ></l-side-menu-element>
                </l-side-menu>
            </div>
            <div class="col-md-10">
                <l-card-content>
                    <router-view></router-view>
                </l-card-content>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";
import LSideMenu from "@/components/LSideMenu";
import LSideMenuElement from "@/components/LSideMenuElement";
import LSideMenuPicture from "@/components/LSideMenuPicture";

import icon from "@/img/icons/settings.png";

export default {
    components: {
        LCardContent,
        LSideMenu,
        LSideMenuElement,
        LSideMenuPicture,
    },
    data() {
        return {
            icon,
        };
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
        }),
        menu() {
            return [
                {
                    show: true,
                    icon: "fal fa-credit-card",
                    label: this.$t("adminSettings.menuBilling"),
                    path: "/team/settings/billing",
                },
                {
                    show: true,
                    type: "space",
                },
                {
                    show: true,
                    icon: "fal fa-cog",
                    label: this.$t("adminSettings.menuAccount"),
                    path: "/team/settings/account",
                },
                {
                    show: true,
                    icon: "fal fa-calendar-star",
                    label: this.$t("adminSettings.menuReviews"),
                    path: "/team/settings/reviews",
                },
                {
                    show: true,
                    icon: "fal fa-bullseye",
                    label: this.$t("adminSettings.menuGoals"),
                    path: "/team/settings/goals",
                },
                {
                    show: true,
                    icon: "fal fa-thumbs-up",
                    label: this.$t("adminSettings.menuFeedback"),
                    path: "/team/settings/feedback",
                },
                {
                    show: true,
                    icon: "fal fa-comments",
                    label: this.$t("adminSettings.menuMeetings"),
                    path: "/team/settings/meetings",
                },
                {
                    show: true,
                    icon: "fal fa-quote-left",
                    label: this.$t("adminSettings.menuSurveys"),
                    path: "/team/settings/surveys",
                },
                {
                    show: true,
                    icon: "fal fa-book-reader",
                    label: this.$t("adminSettings.menuLearning"),
                    path: "/team/settings/learning",
                },
                {
                    show: this.rights.N_VIEW_ALL,
                    icon: "fal fa-bell",
                    label: this.$t("adminSettings.menuNotifications"),
                    path: "/team/settings/notifications",
                },
                {
                    show: true,
                    type: "space",
                },
                {
                    show: true,
                    icon: "fal fa-link",
                    label: this.$t("adminSettings.menuSlack"),
                    path: "/team/settings/slack",
                },
                {
                    show: true,
                    icon: "fal fa-link",
                    label: this.$t("adminSettings.menuMsteams"),
                    path: "/team/settings/msteams",
                },
                {
                    show: true,
                    icon: "fal fa-link",
                    label: this.$t("adminSettings.menuJira"),
                    path: "/team/settings/jira",
                },
                {
                    show: true,
                    icon: "fal fa-link",
                    label: this.$t("adminSettings.menuSSO"),
                    path: "/team/settings/sso",
                },
                {
                    show: true,
                    icon: "fal fa-link",
                    label: this.$t("adminSettings.menuProvisioning"),
                    path: "/team/settings/provisioning",
                },
                {
                    show: true,
                    icon: "fal fa-link",
                    label: this.$t("adminSettings.menuAPI"),
                    path: "/team/settings/api",
                },
                // Extra spaces needed to ensure that the Zendesk Help button doesn't cover
                // the tailend of the menu.
                {
                    show: true,
                    type: "space",
                },
                {
                    show: true,
                    type: "space",
                },
                {
                    show: true,
                    type: "space",
                },
            ];
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.isRouteActive(route.path);
            },
        },
    },
    methods: {
        goTo(path) {
            this.$router.push(path);
        },
        isRouteActive(path) {
            this.menu.forEach(item => {
                this.$set(item, "active", path.startsWith(item.path));
            });
        },
    },
};
</script>

<style scoped></style>
